(function() {
    'use strict';

    angular
        .module('app.classes.frontEndSettings', [])
        .service("frontEndSettingsService", ['API', '$q',
            function(API, $q) {
                var defer;
                var frontEndSettings;
                var inProgress = false;

                function getFrontendSettings() {
                    if (inProgress) {
                        return defer.promise;
                    } else {
                        if (frontEndSettings) {
                            if (!defer) {
                                /* Just to be sure that defer is always initiated. */
                                defer = $q.defer();
                            }
                            defer.resolve($q.when(frontEndSettings));
                        } else {
                            defer = $q.defer();
                            inProgress = true;
                            let api = new API();
                            api.System.GetFrontendSettings().$promise
                            .then(function (data) {
                                inProgress = false;

                                if (data.OrgId === undefined) {
                                    frontEndSettings = {};
                                    frontEndSettings.OrgId = 'ker';
                                    frontEndSettings.LanguageCode = 'de';
                                } else {
                                    frontEndSettings = data;
                                    frontEndSettings.OrgId = frontEndSettings.OrgId.toLowerCase();

                                    if (!frontEndSettings.LanguageCode) {
                                        console.warn('GetFrontendSettings LanguageCode null, using default "de"!');
                                        frontEndSettings.LanguageCode = 'de';
                                    }
                                }

                                if (!frontEndSettings.HomeServerVersion) {
                                    frontEndSettings.HomeServerVersion = '1.3.0.0';
                                }

                                defer.resolve(frontEndSettings);
                            })
                            .catch(error => {
                                inProgress = false;
                                if (error.Code === 'EX_LO_DATAPOINT_006'
                                    && error.Response.data.ExceptionData.Data.RestrictedUser) {
                                        console.error('Are ACL rights for the RestrictedUser set for the system device?');

                                        /* Failsave */
                                        frontEndSettings = {};
                                        frontEndSettings.OrgId = 'ker';
                                        frontEndSettings.LanguageCode = 'de';
                                        frontEndSettings.RestrictedModeEnabled = true;
                                        frontEndSettings.HomeServerVersion = '1.3.0.0';
                                        defer.resolve(frontEndSettings);
                                    }
                            });
                        }
                    }

                    return defer.promise;
                }

                return {
                    getFrontendSettings: getFrontendSettings
                };
            }
        ]);

})();
